import * as React from "react";
import { makeStyles } from "@material-ui/core";

import { Markdown } from "../misc";
import { PersonList } from "../people";
import { StoryGallery } from "../stories";
import { BeaconWrapUpStory, ProjectParticipant } from "../../../api/graphQL/queryModels";
import { ParticipantSorter } from "../../../utils";

interface ComponentProps {
    story: BeaconWrapUpStory;
}

const useStyles = makeStyles((theme) => ({
    header: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(2)
    }
}));

const WrapUpStoryInfo = (props: ComponentProps) => {
    const { story } = props;
    const classes = useStyles();

    const participants: ProjectParticipant[] = ParticipantSorter.filterAndSortProjectParticipants(story.project?.participants || []);

    return (
        <div>
            <div className={classes.header}>
                <PersonList people={participants.map((p) => p.person)} showInactivePeople showText withLink truncate={false} />
            </div>

            <div>
                <StoryGallery images={story.images} />
            </div>
            <div className={classes.header}>
                <Markdown>{story.description}</Markdown>
            </div>
        </div>
    );
};

export default WrapUpStoryInfo;
